import { Component, NgModule } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { Wischnavigation } from '../../../Wischnavigation';


@Component({
	selector: 'page-phone-zusatzinformationen',
	templateUrl: 'ZusatzinformationenPhonePage.html',
})

@NgModule({
	imports: [
		CommonModule
	]
})


export class ZusatzinformationenPhonePage {

	aktuellAngezeigteZusatzinformationen: string | undefined = undefined; // Diese zusätzlichen Infromationen (Zusatzinformationen zum Item, CROm, Symptome, Differentialdiagnosen) werden gerade angezeigt.



	constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public globals: GlobalsSingleton) {
		this.aktuellAngezeigteZusatzinformationen = navParams.get('zusatzinformationen');
	}

	ionViewWillEnter() {
		if (this.globals.isIOS())
			Wischnavigation.iosPreventSafariDefaultnav();
	}



	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot(
				{
				animate : true,
				animation: "ios-transition"
			}
		);

	}

}


// WEBPACK FOOTER //
// ./src/pages/checklist/Phone/ZusatzinformationenPhonePage.ts